import { useDialogStore } from '@/features/common/stores/dialogStore';

export const useGlobalDialogStore = useDialogStore();
